import "./SyncRevenueChart.css";
import React, { Fragment } from "react";
import {
  Category,
  ChartComponent,
  ColumnSeries,
  Inject,
  Legend,
  LineSeries,
  SeriesCollectionDirective,
  SeriesDirective,
} from "@syncfusion/ej2-react-charts";
const SyncRevenueChart = ({ id, ChartData }) => {
  const FirstValue = ChartData[0]?.value;
  const SecondValue = ChartData[1]?.value;
  const ThirdValue = ChartData[2]?.value;
  //   const SecondValue = ChartData[1].value;
  //   const ThirdValue = ChartData[2].value;

  const revenueData = [
    { month: "Jan", sales: FirstValue },
    { month: "Feb", sales: SecondValue },
    { month: "Mar", sales: ThirdValue },
    // { month: "Feb", sales: 0 },
    // { month: "Mar", sales: 0 },
    // { month: "Apr", sales: 0 },
    // { month: "May", sales: 0 },
    // { month: "Jun", sales: 0 },
    // { month: "Jul", sales: 0 },
    // { month: "Aug", sales: 0 },
    // { month: "Sep", sales: 0 },
    // { month: "Oct", sales: 0 },
    // { month: "Nov", sales: 0 },
    // { month: "Dec", sales: 0 },
  ];
  const primaryxAxis = { valueType: "Category" };

  const pointRender = (args) => {
    let seriesColor = [
      "#AD00E8",
      "#AD00E8",
      "#AD00E8",
      //   "#e56590",
      //   "#f8b883",
      //   "#70ad47",
      //   "#dd8abd",
      //   "#7f84e8",
      //   "#7bb4eb",
      //   "#ea7a57",
      //   "#cccccc",
      //   "#1d1d1d",
    ];
    args.fill = seriesColor[args.point.index];
  };

  return (
    <Fragment>
      {ChartData?.length !== 0 && (
        <div className="SyncRevenueChart">
          <ChartComponent
            className="dashboard-revenue-chart"
            pointRender={pointRender}
            id={id}
            primaryXAxis={primaryxAxis}
            // style={{ height: "300px", width: "400px" }}
          >
            <Inject services={[ColumnSeries, Legend, LineSeries, Category]} />
            <SeriesCollectionDirective>
              <SeriesDirective
                dataSource={ChartData}
                xName="month"
                type="Column"
                yName="sales"
                name="Total Revenue"
              />
            </SeriesCollectionDirective>
          </ChartComponent>
        </div>
      )}
    </Fragment>
  );
};

export default SyncRevenueChart;
